import { render, staticRenderFns } from "./DeductStatistic.vue?vue&type=template&id=2d85d00c&scoped=true&"
import script from "./DeductStatistic.vue?vue&type=script&lang=js&"
export * from "./DeductStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DeductStatistic.vue?vue&type=style&index=0&id=2d85d00c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d85d00c",
  null
  
)

export default component.exports